export default __webpack_public_path__ + "static/media/netflixclone.f28b3e83.png";